import React from 'react';

const ComputationScreen = (props) => (
    <div className="computation-screen" >
        {props.children}
    </div >
);

export default ComputationScreen;
